/** @jsxImportSource @emotion/react */
import { RoundedActionLabel } from "../../../components/RoundedActionLabel";
import { OverwriteMenuModalProduct } from "./OverwriteMenuModal";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { colors } from "../../../components/colors";
import { css } from "@emotion/react";

type Props = {
  isHiddenValue: boolean;
  isUnavailableValue: boolean;
  overwriteTitle: string;
  overwritePrice: string | number;
  overwritePriceDelivery: string | number;
  product: OverwriteMenuModalProduct;
  isOnOriginalMenu: boolean;
  onButtonClick: () => void;
  overwritePriceDescription: string;
  hidePriceDescription?: boolean;
};

export const MenuOverwriteActionLabel = ({
  isHiddenValue,
  isUnavailableValue,
  overwriteTitle,
  overwritePrice,
  overwritePriceDelivery,
  isOnOriginalMenu,
  onButtonClick,
  overwritePriceDescription,
  hidePriceDescription,
}: Props) => {
  const isChanged =
    overwriteTitle ||
    overwritePrice ||
    overwritePrice === 0 ||
    overwritePriceDelivery === 0 ||
    overwritePriceDelivery ||
    overwritePriceDescription !== undefined ||
    hidePriceDescription;

  const actionLabelAdditionalStyles = css`
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 10000;
    right: 0;
    background-color: ${isHiddenValue || isUnavailableValue
      ? colors.black
      : isChanged
      ? colors.white
      : "rgba(0, 0, 0, 0.4)"};
    color: ${isHiddenValue ||
    isUnavailableValue ||
    (!isOnOriginalMenu && !isChanged)
      ? colors.white
      : colors.black};
    ${!isOnOriginalMenu &&
    `
    backdrop-filter: blur(2px);
  `}
  `;

  return (
    <RoundedActionLabel
      icon={
        isHiddenValue ? (
          <FontAwesomeIcon icon={solid("eye-slash")} />
        ) : isUnavailableValue ? (
          <FontAwesomeIcon icon={solid("do-not-enter")} />
        ) : isChanged ? (
          <FontAwesomeIcon icon={solid("pen")} />
        ) : (
          <FontAwesomeIcon icon={solid("code-branch")} />
        )
      }
      label={
        isHiddenValue
          ? "Marked hidden"
          : isUnavailableValue
          ? "Marked unavailable"
          : isChanged
          ? "Changed"
          : "Not on main menu"
      }
      onButtonClick={onButtonClick}
      buttonIcon={
        isChanged &&
        !isHiddenValue &&
        !isUnavailableValue && <FontAwesomeIcon icon={solid("rotate-left")} />
      }
      additionalStyles={actionLabelAdditionalStyles}
    />
  );
};
